<mat-sidenav-container class="full-height" [class.mobile-view]="isMobile">
    <mat-sidenav *ngIf="isMobile" #sideBar mode="over">        
        <ig-hub-side-bar #sidebar></ig-hub-side-bar>
    </mat-sidenav>

    <mat-sidenav-content class="full-height">
        <div class="page-header">           
            <button mat-icon-button>
                <mat-icon>menu</mat-icon>
            </button>
            <h1>{{mobileMenuTitle}}</h1>
        </div>
        <div class="ig-container-fluid full-height">
            <ig-row class="full-height">
                <div class="hub-header">
                    <img [src]="imgoingLogo" alt="">
                    <div class="page-title">
                        <span>DIGITAL EXPERIENCE PLATFORM (DXP)</span>
                    </div>
                    <div class="flex actions">
                        <ig-button color="transparent" (trigger)="downloadPDF()" >     
                            EXPORT CONTENT
                        </ig-button>
                        <ig-button class="action" color="transparent" (trigger)="navigateToSupport()">                            
                            CONTACT SUPPORT
                        </ig-button>
                        <div class="action" (click)="logout()" style="margin-top: 5px;">                            
                            LOGOUT
                        </div>
                    </div>
                </div>
                <ig-col class="stick-side-bar" [xs]="4" [lg]="2">
                    <ig-hub-side-bar #sidebar></ig-hub-side-bar>
                </ig-col>
                <ig-col class="hub-right" [xs]="8" [lg]="10">
                    <div class="hub-content">
                        <ig-hub-nav></ig-hub-nav>
                        <router-outlet #outlet></router-outlet>
                    </div>
                </ig-col>
            </ig-row>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/hub.component.html